import { z } from 'zod';

export const passwordSchema = z
    .string()
    .min(8, { message: 'Must be at least 8 characters' })
    .refine((value) => /[A-Z]/.test(value), {
        message: 'Must contain at least one uppercase character',
    })
    .refine((value) => /[a-z]/.test(value), {
        message: 'Must contain at least one lowercase character',
    })
    .refine((value) => /\d/.test(value), {
        message: 'Must contain at least one number',
    })
    .refine((value) => /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(value), {
        message: 'Password must contain a special character',
    });

export const PasswordRequestSchema = z.object({
    email: z
        .string()
        .email({ message: 'Please enter your email address in the format john@example.com.' })
        .min(6, { message: 'Please enter a valid email address.' })
        .max(50, 'Email must be less than 50 characters.'),
});
